module.exports = __webpack_public_path__ + "img/Riaan.5a17aad0.webp";